import { render, staticRenderFns } from "./ViewAnnouncement.vue?vue&type=template&id=f59afe5e&scoped=true"
import script from "./ViewAnnouncement.vue?vue&type=script&lang=js"
export * from "./ViewAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ViewAnnouncement.vue?vue&type=style&index=0&id=f59afe5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59afe5e",
  null
  
)

export default component.exports